export default __webpack_public_path__ + "static/media/taniaThomas.b8928d38.png";